import { User } from '@core/model/user.model'

export class ScopeSubmitter {
  id?: number
  user!: User
  submitted?: boolean
  submittedTs?: Date
}
